import { Box, VStack, Text } from "@chakra-ui/react";

interface AnalysisLogsTerminalProps {
  logs: string[];
}

/*
 * Terminal-style logs display (black background, green text).
 * Shown directly when System Logs is selected from the menu - no collapsible wrapper.
 */
const AnalysisLogsTerminal: React.FC<AnalysisLogsTerminalProps> = ({ logs }) => {
  return (
    <Box
      maxH="300px"
      overflowY="auto"
      bg="black"
      borderRadius="md"
      p={3}
      fontFamily="mono"
    >
      <VStack spacing={1} align="stretch">
        {logs?.map((log, index) => (
          <Text
            key={index}
            fontSize="xs"
            color="green.200"
            mb={0}
            whiteSpace="pre-wrap"
            wordBreak="break-word"
            align="left"
          >
            {log}
          </Text>
        ))}
      </VStack>
    </Box>
  );
};

export default AnalysisLogsTerminal;
